import type { ContentType } from "@/cms/blocks/registry/types";
import { ArticleTeaser } from "./ArticleTeaser";
import { ProductListTeaser } from "./ProductListTeaser";
import type { ContentTeaserComponent, ContentTeaserProps } from "./types";

const TEASER_REGISTRY: Partial<Record<ContentType, ContentTeaserComponent>> = {
  PRODUCT_LIST: ProductListTeaser,
  ARTICLE: ArticleTeaser,
};

export function renderContentTeaser(props: ContentTeaserProps) {
  const Renderer = props.type
    ? TEASER_REGISTRY[props.type as ContentType]
    : undefined;
  if (!Renderer) return null;
  return <Renderer {...props} />;
}
